import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('tip'), _c('my-enter-search', {
    on: {
      "search": _vm.handleSearch
    }
  }, [_c('a-form', {
    attrs: {
      "layout": "inline",
      "from": _vm.searchData
    }
  }, [_c('a-form-item', [_c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "allow-clear": false
    },
    model: {
      value: _vm.searchData.code_field,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "code_field", $$v);
      },
      expression: "searchData.code_field"
    }
  }, [_c('a-select-option', {
    attrs: {
      "value": "workorder_code"
    }
  }, [_vm._v(_vm._s(_vm.t('工单号')))]), _c('a-select-option', {
    attrs: {
      "value": "relation_order_code"
    }
  }, [_vm._v(_vm._s(_vm.t('关联单号')))]), _c('a-select-option', {
    attrs: {
      "value": "title"
    }
  }, [_vm._v(_vm._s(_vm.t('主题')))])], 1), _c('a-input', {
    staticClass: "form-item-input",
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "data-permission": "case_ticket_code_value",
      "id": "case_ticket_code_value",
      "allowClear": ""
    },
    model: {
      value: _vm.searchData.code_value,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "code_value", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "searchData.code_value"
    }
  })], 1)], 1), _c('a-form-item', [_c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "fbu-analyse-name": $t("\u4ED3\u5E93"),
      "data-permission": "case_ticket_warehouse_code",
      "id": "case_ticket_warehouse_code",
      "allowClear": "",
      "placeholder": _vm.t('仓库'),
      "show-tip": ""
    },
    model: {
      value: _vm.searchData.warehouse_code,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "warehouse_code", $$v);
      },
      expression: "searchData.warehouse_code"
    }
  }, _vm._l(_vm.warehouseList, function (item) {
    return _c('a-select-option', {
      key: item.warehouse_code,
      attrs: {
        "value": item.warehouse_code
      }
    }, [_vm._v(_vm._s(item.warehouse_name))]);
  }), 1), _c('my-select', {
    staticClass: "form-item-select",
    staticStyle: {
      "width": "110px"
    },
    attrs: {
      "fbu-analyse-name": $t("\u5DE5\u5355\u72B6\u6001"),
      "data-permission": "case_ticket_status",
      "id": "case_ticket_status",
      "placeholder": _vm.t('工单状态'),
      "allowClear": "",
      "show-tip": ""
    },
    model: {
      value: _vm.searchData.status,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "status", $$v);
      },
      expression: "searchData.status"
    }
  }, _vm._l(_vm.workOrderStatusList, function (item, index) {
    return _c('a-select-option', {
      key: index,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.text))]);
  }), 1), _c('my-select', {
    staticClass: "form-item-select",
    staticStyle: {
      "width": "110px"
    },
    attrs: {
      "fbu-analyse-name": $t("\u5DE5\u5355\u7C7B\u578B"),
      "data-permission": "case_ticket_type",
      "id": "case_ticket_type",
      "placeholder": _vm.t('工单类型'),
      "allowClear": "",
      "show-tip": ""
    },
    model: {
      value: _vm.searchData.order_type,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "order_type", $$v);
      },
      expression: "searchData.order_type"
    }
  }, _vm._l(_vm.workOrderTypeList, function (item, index) {
    return _c('a-select-option', {
      key: index,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.text))]);
  }), 1)], 1)], 1), _c('a-form-item', [_c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "allow-clear": false
    },
    model: {
      value: _vm.searchData.time_field,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "time_field", $$v);
      },
      expression: "searchData.time_field"
    }
  }, [_c('a-select-option', {
    attrs: {
      "value": "created_at"
    }
  }, [_vm._v(_vm._s(_vm.t('创建时间')))]), _c('a-select-option', {
    attrs: {
      "value": "last_updated_at"
    }
  }, [_vm._v(_vm._s(_vm.t('更新时间')))])], 1), _c('my-range-picker', {
    attrs: {
      "data-permission": "case_ticket_datetime",
      "id": "case_ticket_datetime",
      "placeholder": [_vm.t('开始'), _vm.t('结束')],
      "format": "YYYY/MM/DD"
    },
    model: {
      value: _vm.searchData.time_range,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "time_range", $$v);
      },
      expression: "searchData.time_range"
    }
  })], 1)], 1), _c('a-form-item', [_c('a-button', {
    attrs: {
      "type": "primary",
      "ghost": "",
      "fbu-analyse-name": $t("\u641C\u7D22")
    },
    on: {
      "click": _vm.handleSearch
    }
  }, [_c('a-icon', {
    attrs: {
      "type": "search"
    }
  }), _vm._v(" " + _vm._s(_vm.t('搜索')) + " ")], 1), _c('a-button', {
    staticClass: "margin-left",
    attrs: {
      "fbu-analyse-name": $t("\u91CD\u7F6E")
    },
    on: {
      "click": _vm.handleClear
    }
  }, [_vm._v(_vm._s(_vm.t('重置')))])], 1)], 1)], 1), _c('div', {
    staticClass: "mt-5 handle-cont"
  }, [_c('div', [_vm._v(" " + _vm._s(_vm.t('已选')) + " " + _vm._s(_vm.t('common', '：')) + _vm._s(_vm.selectedList.length) + " "), _c('a-dropdown', {
    directives: [{
      name: "permission",
      rawName: "v-permission",
      value: 'case_ticket_export',
      expression: "'case_ticket_export'"
    }]
  }, [_c('a-menu', {
    attrs: {
      "slot": "overlay"
    },
    slot: "overlay"
  }, [_c('a-menu-item', {
    key: "1",
    attrs: {
      "data-permission": "case_ticket_export_all",
      "id": "case_ticket_export_all",
      "fbu-analyse-name": $t("\u5BFC\u51FA\u5168\u90E8")
    },
    on: {
      "click": function ($event) {
        return _vm.handleExport(true);
      }
    }
  }, [_vm._v(_vm._s(_vm.t('导出全部')))]), _c('a-menu-item', {
    key: "2",
    attrs: {
      "data-permission": "case_ticket_export_selected",
      "id": "case_ticket_export_selected",
      "fbu-analyse-name": $t("\u5BFC\u51FA\u5DF2\u9009")
    },
    on: {
      "click": function ($event) {
        return _vm.handleExport(false);
      }
    }
  }, [_vm._v(_vm._s(_vm.t('导出已选')))])], 1), _c('a-button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "fbu-analyse-name": $t("\u5BFC\u51FA")
    }
  }, [_vm._v(" " + _vm._s(_vm.t('导出')) + " "), _c('a-icon', {
    attrs: {
      "type": "down"
    }
  })], 1)], 1)], 1)]), _c('a-skeleton', {
    attrs: {
      "active": "",
      "loading": _vm.loadingStatus
    }
  }, [_c('my-table', {
    staticClass: "box min-ptext",
    attrs: {
      "columns": _vm.columns,
      "fixed-header": "",
      "bordered": "",
      "is-filter-box": "",
      "name": "caseTicketList",
      "data-source": _vm.data,
      "rowKey": "work_order_id",
      "row-selection": _vm.rowSelection
    },
    scopedSlots: _vm._u([{
      key: "code",
      fn: function (ref) {
        var record = ref.record;
        return _c('div', {}, [_c('router-link', {
          attrs: {
            "to": {
              name: 'WorkOrderDetailPage',
              query: {
                code: record.workorder_code
              }
            }
          }
        }, [_vm._v(_vm._s(record.workorder_code))])], 1);
      }
    }, {
      key: "rangTime",
      fn: function (ref) {
        var record = ref.record;
        return _c('div', {}, [_c('p', [_vm._v(_vm._s(_vm.t('创建时间')) + " " + _vm._s(_vm.t('common', '：')) + _vm._s(record.created_at))]), _c('p', [_vm._v(_vm._s(_vm.t('更新时间')) + " " + _vm._s(_vm.t('common', '：')) + _vm._s(record.last_updated_at))])]);
      }
    }, {
      key: "relation_order_code",
      fn: function (ref) {
        var record = ref.record;
        return _c('div', {}, [_c('text-ellipses', {
          attrs: {
            "data": record.relation_order_code
          }
        })], 1);
      }
    }, {
      key: "warehouse_desc",
      fn: function (ref) {
        var record = ref.record;
        return _c('div', {}, [_vm._v(" " + _vm._s(record.warehouse_code) + "[" + _vm._s(record.warehouse_desc) + "] ")]);
      }
    }, {
      key: "titleContent",
      fn: function (ref) {
        var record = ref.record;
        return _c('div', {}, [_c('text-ellipses', {
          attrs: {
            "data": record.title
          }
        })], 1);
      }
    }, {
      key: "operation",
      fn: function (ref) {
        var record = ref.record;
        return _c('my-operation', {}, [_c('router-link', {
          directives: [{
            name: "permission",
            rawName: "v-permission",
            value: 'case_ticket_edit',
            expression: "'case_ticket_edit'"
          }, {
            name: "show",
            rawName: "v-show",
            value: record.status === 2,
            expression: "record.status === 2"
          }],
          staticClass: "mr-10",
          attrs: {
            "data-permission": "case_ticket_edit",
            "id": "case_ticket_edit",
            "to": {
              name: 'EditWorkOrderPage',
              query: {
                code: record.workorder_code
              },
              params: {
                noCache: '1'
              }
            }
          }
        }, [_vm._v(_vm._s(_vm.t('编辑')))]), _c('a', {
          directives: [{
            name: "permission",
            rawName: "v-permission",
            value: 'case_ticket_discard',
            expression: "'case_ticket_discard'"
          }, {
            name: "show",
            rawName: "v-show",
            value: record.status === _vm.$enum.helper.CaseTicketStatusEnum.PENDING,
            expression: "record.status === $enum.helper.CaseTicketStatusEnum.PENDING"
          }],
          staticClass: "mr-10",
          attrs: {
            "data-permission": "case_ticket_abandon",
            "id": "case_ticket_abandon",
            "fbu-analyse-name": $t("\u5E9F\u5F03")
          },
          on: {
            "click": function ($event) {
              return _vm.handleAbandon(record['workorder_code']);
            }
          }
        }, [_vm._v(_vm._s(_vm.t('废弃')))])], 1);
      }
    }])
  }), _c('div', {
    staticClass: "pagination-box"
  }, [_c('my-pagination', {
    attrs: {
      "current": _vm.searchData.page_index,
      "name": "caseTicketList",
      "total": _vm.total,
      "page-size": _vm.searchData.page_size
    },
    on: {
      "update:pageSize": function ($event) {
        return _vm.$set(_vm.searchData, "page_size", $event);
      },
      "update:page-size": function ($event) {
        return _vm.$set(_vm.searchData, "page_size", $event);
      },
      "onChange": _vm.handlePageChange
    }
  })], 1)], 1)], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };